
import * as React from "react";
import { Glyphicon } from "react-bootstrap";
import { Tabs, Tab } from 'material-ui/Tabs';
import { EstructuraEmpresa, EstructuraSuraEmpresa } from "../modelo/EstructuraEmpresa";
import InformacionBasicaEmpresa from "./InformacionBasicaEmpresa";
import TablaEmpleadosEmpresa from "./TablaEmpleadosEmpresa";
import TablaCentrosTrabajoEmpresa from "./TablaCentrosTrabajoEmpresa";
import TablaSedesEmpresa from "./TablaSedesEmpresa";

const estiloPestaña = {
    backgroundColor: '#023a86',
    height: '68px',
    fontSize: '12px'
};

export default class PestañaEstructuraEmpresa extends React.Component<PestañaEstructuraEmpresaProps, any> {

    constructor(props: any) {
        super(props);
    }

    render() {
        return(
            <Tabs initialSelectedIndex={0}>
                <Tab
                    icon={<Glyphicon className={"info-sign icon-label"} glyph={"info-sign"}/>}
                    label="Información Básica Empresa" 
                    style={estiloPestaña}>
                    <InformacionBasicaEmpresa 
                        consecutivoConsulta={this.props.consecutivoConsulta}
                        estructuraEmpresa={this.props.estructuraEmpresa} 
                        estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    />
                </Tab>
                <Tab
                    icon={<Glyphicon className={"map-marker icon-label"} glyph={"map-marker"}/>}
                    label="Sedes Empresa"
                    style={estiloPestaña}>
                    <TablaSedesEmpresa 
                        estructuraEmpresa={this.props.estructuraEmpresa}
                        estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    />
                </Tab>
                <Tab
                    icon={<Glyphicon className={"home icon-label"} glyph={"home"}/>}
                    label="Centros de Trabajo"
                    style={estiloPestaña}>
                    <TablaCentrosTrabajoEmpresa 
                        estructuraEmpresa={this.props.estructuraEmpresa}
                        estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    />
                </Tab>
                <Tab
                    icon={<Glyphicon className={"user icon-label"} glyph={"user"}/>}
                    label="Empleados Empresa"
                    style={estiloPestaña}>
                    <TablaEmpleadosEmpresa 
                        estructuraEmpresa={this.props.estructuraEmpresa}
                        estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    />
                </Tab>
            </Tabs>
        );
    }
}

interface PestañaEstructuraEmpresaProps {
    consecutivoConsulta: number,
    estructuraEmpresa: EstructuraEmpresa,
    estructuraSuraEmpresa?: EstructuraSuraEmpresa
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/componentes/PestañaEstructuraEmpresa.tsx